import { defineComponent } from "vue";

import { PAGE_NAME } from "./attributes";
import { SettingsTabValue } from "./model";
import { RoutesName } from "@/shared/constants/enums";

import {
  SettingsTabs,
  SettingsKycKyb,
  SettingsRequisites,
  SettingsMarketTest,
} from "@/components/pages/settings";

type Component =
  | typeof SettingsKycKyb
  | typeof SettingsRequisites
  | typeof SettingsMarketTest;

export default defineComponent({
  name: PAGE_NAME,
  components: {
    SettingsTabs,
    SettingsKycKyb,
    SettingsRequisites,
    SettingsMarketTest,
  },
  data() {
    return {
      tab: SettingsTabValue.requisites,
      userRepo: this.$projectServices.userRepo,
    };
  },
  computed: {
    displayedComponent(): Component {
      switch (this.tab) {
        case SettingsTabValue["market-test"]:
          return SettingsMarketTest;
        case SettingsTabValue["kyc-kyb"]:
          return SettingsKycKyb;
        case SettingsTabValue.requisites:
          return SettingsRequisites;
        default:
          return SettingsRequisites;
      }
    },
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(value) {
        this.tab = Object.values(SettingsTabValue).includes(
          value as SettingsTabValue
        )
          ? (value as SettingsTabValue)
          : SettingsTabValue.requisites;
      },
    },
  },
  methods: {
    tabChange(tabValue: SettingsTabValue): void {
      if (
        tabValue === SettingsTabValue["kyc-kyb"] &&
        !this.userRepo.isVerified
      ) {
        this.$router.push({ name: RoutesName.verification });
        return;
      }

      this.tab = tabValue;
      this.$router.replace({ query: { ...this.$route.query, tab: tabValue } });
    },
  },
});
